import { MouseEventHandler } from "react"

import { Checkbox } from "../../../../components/base/control/Checkbox"
import { classNames } from "../../../../lib/classNames"
import { TableCell, TableCellProps, TableCellWidth } from "../TableCell"

export interface TableCheckboxCellProps
  extends Omit<TableCellProps, "children" | "width"> {
  isChecked: boolean
  onChangeIsChecked: ({
    isChecked,
    isShiftPressed,
  }: {
    isChecked: boolean
    isShiftPressed: boolean
  }) => void
}

export function TableCheckboxCell({
  isChecked,
  onChangeIsChecked,
  className,
  ...otherProps
}: TableCheckboxCellProps) {
  const onClick: MouseEventHandler<HTMLTableCellElement> = (e) => {
    e.stopPropagation()
  }

  return (
    <TableCell
      width={TableCellWidth.ExtraExtraSmall}
      className={classNames(
        "cursor-default select-none border-r-0 text-right align-middle leading-none",
        className
      )}
      onClick={onClick}
      {...otherProps}
    >
      <Checkbox
        checked={isChecked}
        onClick={(event) => {
          if (!event.shiftKey) return
          // shift click this row
          event.preventDefault()
          onChangeIsChecked({
            isChecked: !isChecked,
            isShiftPressed: true,
          })
        }}
        onChange={(isChecked) =>
          // click this row
          onChangeIsChecked({ isChecked, isShiftPressed: false })
        }
      />
    </TableCell>
  )
}
